import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "ticketStatus",
})
export class TicketStatusPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value === 0) {
      return '<span class="badge badge-info">Pending</span>';
    }
    return '<span class="badge badge-success">Resolved</span>';
  }
}
